import { ApolloError, QueryHookOptions, useQuery } from '@apollo/client';

import {
  ProfileMinQuery,
  ProfileMinQueryVariables,
  UserProfile
} from '@/__generated_graphql__/graphql';
import { GET_PROFILE_MIN } from '@/graphql/queries';

type UseGetMinProfileResult = {
  profile: UserProfile | undefined;
  loading: boolean;
  error: ApolloError | undefined;
};

type UseGetMinProfileProps = {
  cacheFirst?: boolean;
};

export const useGetMinProfile = ({
  cacheFirst = true
}: UseGetMinProfileProps = {}): UseGetMinProfileResult => {
  const queryOptions: QueryHookOptions<
    ProfileMinQuery,
    ProfileMinQueryVariables
  > = cacheFirst
    ? {
        fetchPolicy: 'cache-and-network',
        nextFetchPolicy: 'cache-first',
        notifyOnNetworkStatusChange: true
      }
    : {};

  const { data, loading, error } = useQuery<
    ProfileMinQuery,
    ProfileMinQueryVariables
  >(GET_PROFILE_MIN, queryOptions);

  const profile = data?.profile as UserProfile;

  return { profile, loading, error };
};
